<template>
  <div>
  <el-select
    name="country"
    v-validate="{required: true}"
    placeholder="Select"
    filterable
    prefix-icon="el-icon-search" 
    remote
    :remote-method="countrySearch"
    default-first-option
    :allow-create="false"
    v-model="country"
    :value="country ? country.id : null"
    :loading="loadingCountry"
    v-loading="loadingCountry"
    element-loading-spinner="qc-spinner"
    :class="{'has-error': errors.has('country')}"
    value-key="id"
    class="verification-select"
    @input="$emit('input', $event)" >
    <el-option-group v-if="countryOptions != null && countryOptions.length > 0" :label="'Type to search and select an option below'">
      <el-option
        v-for="item in countryOptions"
        :key="item.id"
        :label="item.name"
        :value="item"
        :disabled="item.disabled">
      </el-option>
    </el-option-group>
  </el-select>
  <small class="text-danger" v-show="errors.has('country')">
    {{ errors.first('country') }}
  </small>
  </div>
</template>

<script>
export default {
  name: 'country-select',
  inject: ['$validator'],
  props: {
    value: Object,
  },
  data () {
    return {
      country: this.value,
      loadingCountry: false,
      countryOptions: this.value ? [this.value] : []
    }
  },
  mounted () {
    this.countrySearch('')
  },
  activated () {
    this.countrySearch('')
  },
  methods: {
    countrySearch(query) {
      if(query != null) {
        this.loadingCountry = true
        this.doCountrySearch(query)
      }
    },
    doCountrySearch:_.debounce(function(query) {
      this.$api.searchAccountCountries(query)
        .then(response => {
          this.countryOptions = []
          var foundUS = null
          var foundGB = null
          response.data.forEach(country => {
            if(country.id == 'US') {
              foundUS = country
            } else if(country.id == 'GB') {
              foundGB = country
            } else {
              this.countryOptions.push(country)
            }
          })
          if(foundUS) {
            this.countryOptions.unshift(foundUS)
          }
          if(foundGB) {
            this.countryOptions.unshift(foundGB)
          }
          this.loadingCountry = false
        })
        .catch(error => {
          console.log("Failed to load countries")
          console.log(error)
          this.loadingCountry = false
        })  
    }, 200)
  }
}
</script>